import React from 'react';
import { BrandText } from 'design-comuni-plone-theme/components/ItaliaTheme';

const BrandTextFooter = () => {
  return <BrandText />;
};

export default BrandTextFooter;
